export default "__VITE_ASSET__Bb$za2yz__"